export const messages = {
  en: {
    ownerRepairManage: {
      queryCondition: 'Query Condition',
      phoneRepair: 'Phone Repair',
      register: 'Register',
      all: 'All',
      placeholder: {
        repairId: 'Please input repair id',
        repairName: 'Please input repair name',
        tel: 'Please input tel',
        repairType: 'Please select repair type',
        state: 'Please select state'
      },
      table: {
        repairId: 'Repair Id',
        location: 'Location',
        repairType: 'Repair Type',
        repairName: 'Repair Name',
        tel: 'Tel',
        appointmentTime: 'Appointment Time',
        timeout: 'Timeout',
        createTime: 'Create Time',
        state: 'State',
        operation: 'Operation',
        scheduledTask: '(Scheduled Task)'
      },
      tip1: 'Note: Before using this function, please go to Repair Management;',
      tip2: 'For general owner housing repairs, we must add a non-public area type to report repairs normally.',
       
    },
    addOwnerRepair: {
        title: 'Repair Registration',
        repairScope: 'Repair Scope',
        belongBuilding: 'Belong Building',
        belongUnit: 'Belong Unit',
        belongRoom: 'Belong Room',
        repairType: 'Repair Type',
        repairName: 'Repair Name',
        tel: 'Contact',
        appointmentTime: 'Appointment Time',
        context: 'Repair Content',
        placeholder: {
          appointmentTime: 'Please select appointment time',
          repairScope: 'Please select repair scope',
          repairType: 'Please select repair type',
          repairName: 'Please input repair name',
          tel: 'Please input tel',
          context: 'Please input repair content',
        },
        community: 'Community',
        building: 'Building',
        unit: 'Unit',
        room: 'Room',
        buildingSuffix: ' Building',
        unitSuffix: ' Unit',
        roomSuffix: ' Room'
      },
      editOwnerRepair: {
        title: 'Edit Owner Repair',
        repairType: 'Repair Type',
        repairName: 'Repair Name',
        tel: 'Contact',
        appointmentTime: 'Appointment Time',
        context: 'Repair Content',
        placeholder: {
          appointmentTime: 'Please select appointment time'
        }
      },
      deleteOwnerRepair: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this repair record?'
      },
  },
  zh: {
    ownerRepairManage: {
      queryCondition: '查询条件',
      phoneRepair: '电话报修',
      register: '登记',
      all: '全部',
      placeholder: {
        repairId: '请输入工单编号',
        repairName: '请输入报修人',
        tel: '请输入报修电话',
        repairType: '请选择报修类型',
        state: '请选择报修状态'
      },
      table: {
        repairId: '工单编号',
        location: '位置',
        repairType: '报修类型',
        repairName: '报修人',
        tel: '联系方式',
        appointmentTime: '预约时间',
        timeout: '超时时间',
        createTime: '提交时间',
        state: '状态',
        operation: '操作',
        scheduledTask: '(定时任务处理)'
      },
      tip1: '注意：此功能使用前 请先到 报修管理；',
      tip2: '一般业主房屋报修 我们必须要添加一个非公共区域的类型才能正常报修'
    },
    addOwnerRepair: {
        title: '报修登记',
        repairScope: '报修范围',
        belongBuilding: '归属楼栋',
        belongUnit: '归属单元',
        belongRoom: '归属房屋',
        repairType: '报修类型',
        repairName: '报修人',
        tel: '联系方式',
        appointmentTime: '预约时间',
        context: '报修内容',
        placeholder: {
          appointmentTime: '请选择预约时间',
          repairScope: '请选择报修范围',
          repairType: '请选择报修类型',
          repairName: '请输入报修人',
          tel: '请输入联系方式',
          context: '请输入报修内容',
        },
        community: '园区',
        building: '楼栋',
        unit: '单元',
        room: '房屋',
        buildingSuffix: '栋',
        unitSuffix: '单元',
        roomSuffix: '室'
      },
      editOwnerRepair: {
        title: '修改业主报修',
        repairType: '报修类型',
        repairName: '报修人',
        tel: '联系方式',
        appointmentTime: '预约时间',
        context: '报修内容',
        placeholder: {
          appointmentTime: '请选择预约时间'
        }
      },
deleteOwnerRepair: {
        title: '请确认您的操作',
        confirmText: '确定删除业主报修？'
      },
  },
  'zh-TW': {
    ownerRepairManage: {
      queryCondition: '查詢條件',
      phoneRepair: '電話報修',
      register: '登記',
      all: '全部',
      placeholder: {
        repairId: '請輸入工單編號',
        repairName: '請輸入報修人',
        tel: '請輸入報修電話',
        repairType: '請選擇報修類型',
        state: '請選擇報修狀態'
      },
      table: {
        repairId: '工單編號',
        location: '位置',
        repairType: '報修類型',
        repairName: '報修人',
        tel: '聯繫方式',
        appointmentTime: '預約時間',
        timeout: '超時時間',
        createTime: '提交時間',
        state: '狀態',
        operation: '操作',
        scheduledTask: '(定時任務處理)'
      },
      tip1: '注意：此功能使用前 請先到 報修管理；',
      tip2: '一般業主房屋報修 我們必須要添加一個非公共區域的類型才能正常報修'
    },
    addOwnerRepair: {
        title: '報修登記',
        repairScope: '報修範圍',
        belongBuilding: '歸屬樓棟',
        belongUnit: '歸屬單元',
        belongRoom: '歸屬房屋',
        repairType: '報修類型',
        repairName: '報修人',
        tel: '聯繫方式',
        appointmentTime: '預約時間',
        context: '報修內容',
        placeholder: {
          appointmentTime: '請選擇預約時間',
          repairScope: '請選擇報修範圍',
          repairType: '請選擇報修類型',
          repairName: '請輸入報修人',
          tel: '請輸入聯繫方式',
          context: '請輸入報修內容',
        },
        community: '小區',
        building: '樓棟',
        unit: '單元',
        room: '房屋',
        buildingSuffix: '棟',
        unitSuffix: '單元',
        roomSuffix: '室'
      },
      editOwnerRepair: {
        title: '修改業主報修',
        repairType: '報修類型',
        repairName: '報修人',
        tel: '聯繫方式',
        appointmentTime: '預約時間',
        context: '報修內容',
        placeholder: {
          appointmentTime: '請選擇預約時間'
        }
      },
      deleteOwnerRepair: {
        title: '確認操作',
        confirmText: '確定刪除業主報修？'
      },
  }
}